import * as React from 'react';
import System from 'src/helper/system';
const SoATermsPopup = ({ SetStatus }) => {
    const { translation: t } = System;

    return (
        <div className="avnet-modal modal-630">
            <div className="avnet-modal-inner">
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => SetStatus(false)}>×</button>
                <div className="modal-header justify-content-center">
                    <h1 className="pcn-modal-heading">{t('soaTermsPopUpTitle')}</h1>
                </div>
                <div className="modal-body">
                    <div className="soaTermsPopup-content">
                        <div className="soaTermsPopup-text"><p>{t('soaTermsPopUpText')}</p>
                            <p>{t('soaTermsHeadingInfo1')}</p>
                            <p>{t('soaTermsHeadingInfo2')}</p>
                            <ul className='list-unstyled'>
                                <li dangerouslySetInnerHTML={{ __html: t('soaTermsHeadingCondition1') }}></li>
                                <li>{t('soaTermsHeadingCondition2')}</li>
                                <li>{t('soaTermsHeadingCondition3')}</li>
                                <li>{t('soaTermsHeadingCondition4')}</li>
                                <li>{t('soaTermsHeadingCondition5')} <u><a href="https://www.bis.doc.gov/index.php/documents/regulations-docs/2343-part-744-control-policy-end-user-and-end-use-based-2/file" target="_blank" title="" class="soaTermsPopupHyperlink">{t('soaTermsHeadingCondition5LinkText')}</a></u>.</li>
                                <li>{t('soaTermsHeadingCondition6')} <u><a href="https://www.bis.doc.gov/index.php/documents/regulations-docs/2343-part-744-control-policy-end-user-and-end-use-based-2/file" target="_blank" title="" class="soaTermsPopupHyperlink">{t('soaTermsHeadingCondition6LinkText')}</a></u>.</li>
                                <li>{t('soaTermsHeadingCondition7')}</li>
                            </ul>
                            <p>{t('soaTermsPara1')}</p>
                            <p>{t('soaTermsPara2')}</p>
                            <p><strong><u><a href="https://www.bis.doc.gov/index.php/documents/regulations-docs/2344-part-772-definitions-of-terms-2/file" target="_blank" title="" class="soaTermsPopupHyperlink">{t('soaTermsPara3')}</a></u></strong></p>
                            <ul className='list-unstyled'>
                                <li>{t('soaTermsCondition1')}</li>
                                <li>{t('soaTermsCondition2')}</li>
                                <li>{t('soaTermsCondition3')}</li>
                                <li>{t('soaTermsCondition31')}</li>
                                <li>{t('soaTermsCondition32')}</li>
                                <li>{t('soaTermsCondition33')}</li>
                                <li>{t('soaTermsCondition4')}</li>
                                <li>{t('soaTermsCondition5')} <u><a href="https://www.bis.doc.gov/index.php/documents/regulations-docs/2343-part-744-control-policy-end-user-and-end-use-based-2/file" target="_blank" title="" class="soaTermsPopupHyperlink">{t('soaTermsCondition5LinkText')}</a></u>{t('soaTermsCondition5Text')}</li>
                                <li>{t('soaTermsCondition6')}</li>
                                <li>{t('soaTermsCondition7')}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="modal-footer text-center">
                    <div className="modal-footer-actions">
                        <button
                            type="button"
                            className="bs5 btn btn-primary minw-auto"
                            onClick={() => SetStatus(false)}
                        >
                            CLOSE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SoATermsPopup;
